module.exports = __webpack_public_path__ + "static/assets/fd4b34ecdc78f9e39b213db9a1f6e6b4.png";